export default __webpack_public_path__ + "static/media/Modelo 3.c3960aec.png";